export var PreCallTestStatus;
(function (PreCallTestStatus) {
    PreCallTestStatus["FAILED"] = "FAILED";
    PreCallTestStatus["FINISHED"] = "FINISHED";
    PreCallTestStatus["INITIAL"] = "INITIAL";
    PreCallTestStatus["RUNNING"] = "RUNNING";
})(PreCallTestStatus || (PreCallTestStatus = {}));
